"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitiesManager = void 0;
const card_stack_1 = require("./card-stack");
const logic_types_1 = require("../logic-types");
const card_column_1 = require("./card-column");
class EntitiesManager {
    get isGameCompleted() {
        return (this.cardStackCurrent.cardCount === 0 &&
            this.cardStackNext.cardCount === 0 &&
            !this.board.deck.hasCards);
    }
    get remainingCards() {
        return this.board.deck.cardCount + this.cardStackNext.cardCount;
    }
    constructor(board, logicEventQueue, logicVersion) {
        this.board = board;
        this.logicEventQueue = logicEventQueue;
        this.logicVersion = logicVersion;
        this.cardStackCurrent = new card_stack_1.CardStack(logic_types_1.PileId.CardStackCurrent, board, logicVersion);
        this.cardStackNext = new card_stack_1.CardStack(logic_types_1.PileId.CardStackNext, board, logicVersion);
        this.cardColumns = new Map(card_column_1.CardColumn.allColumnIds.map((pileId) => [
            pileId,
            new card_column_1.CardColumn(pileId, board, logicVersion),
        ]));
    }
    cardColumn(pileId) {
        const column = this.cardColumns.get(pileId);
        if (!column) {
            throw new Error(`CardColumn not found for id: ${pileId}`);
        }
        return column;
    }
    allColumnsClone() {
        return new Map(Array.from(this.cardColumns.entries()).map(([pileId, column]) => [
            pileId,
            column.clone(),
        ]));
    }
}
exports.EntitiesManager = EntitiesManager;
